import axios from "../../../util/axios";

export default {
    /** 查询溯源码历史记录 */
    queryHistory: (originalCode, codeType) => axios.get({url: "/order/stock/original/queryHistory", data: {originalCode, codeType}}),
        /** 查询溯源码历史记录 */
    queryHistorySingle: (originalCode, codeType) => axios.get({url: "/order/stock/original/queryHistorySingle", data: {originalCode, codeType}}),
}